import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth.service';

export const institutionGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);

  let userProfile: any;
  authService.profile$.subscribe((profile) => {
    userProfile = profile;
  });

  if (
    userProfile &&
    (userProfile.attributes.userType[0] == 'Institution' ||
      userProfile.attributes.userType[0] == '2')
  )
    return true;
  else return false;
};
